import { CleaningMission } from '@silbo/core';
import { TFunction } from 'i18next';

/** Le dernier démarrage : après une interruption, le temps d'arrêt ne compte pas. */
export const lastStartedAt = (mission: CleaningMission): Date | undefined =>
  mission.history.filter((entry) => entry.action === 'started').at(-1)?.at;

export const formatElapsed = (from: Date, now: Date): string => {
  const minutes = Math.max(0, Math.floor((now.getTime() - from.getTime()) / 60000));
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours < 24) {
    return rest ? `${hours} h ${String(rest).padStart(2, '0')}` : `${hours} h`;
  }
  const days = Math.floor(hours / 24);
  const restHours = hours % 24;
  return restHours ? `${days} j ${restHours} h` : `${days} j`;
};

export const ago = (t: TFunction<'environmental-cleaning'>, from: Date, now: Date): string =>
  now.getTime() - from.getTime() < 60000
    ? t('missions.row.justNow')
    : t('missions.row.ago', { duration: formatElapsed(from, now) });
